<template>
  <div class="link-more" @click="goToNews(news)">
    <button :class="['small-btn', isType(news, [contentTypes.redirect]) ? 'small-btn--active' : 'small-btn--article']">
      {{ getNewsType(news) }}
    </button>
    <p class="link-title">{{ news.generalView && news.generalView.mediaTitle }}</p>
  </div>
</template>
<script>
import { CONTENT_TYPES } from "../../../store/enums"
import { computed, reactive, toRefs } from "@vue/composition-api"
import useDetailItem from "../../mixins/useDetailItem"

export default {
  props: ["news", "offerId", "sceneId", "iformat", "pfStructure", "clickAction", "index"],
  setup(props, { root }) {
    const { isType, goToContentDetail } = useDetailItem(root)
    const data = reactive({
      contentTypes: CONTENT_TYPES,
      placeholderBg: require("../../../../ui/assets/mobile/images/placeholder-bg.png"),
      tagsList: computed(() => {
        if (props.news.generalView && props.news.generalView.mediaTags && props.news.generalView.mediaTags.length) {
          return props.news.generalView.mediaTags.map((mediaTag, index) => {
            if (mediaTag && mediaTag.TagWords && index < 3) {
              return mediaTag.TagWords
            }
            if (mediaTag && mediaTag.Status && mediaTag.Name && index < 3) {
              return mediaTag.Name
            }
          })
        } else {
          return []
        }
      })
    })

    const getNewsType = news => {
      let type = "活动"
      let contentType = parseInt(news.contentType)

      switch (contentType) {
        case CONTENT_TYPES.imageText:
          type = "文章"
          break

        case CONTENT_TYPES.longVideo:
        case CONTENT_TYPES.shortVideo:
          type = "视频"
          break

        // 自定义跳转运营位
        case CONTENT_TYPES.redirect:
          type = "活动"
          break
      }

      return type
    }

    const goToNews = content => {
      if (props.clickAction) props.clickAction()

      goToContentDetail({
        content,
        contentType: content.contentType * 1,
        iformat: props.iformat,
        pfStructure: props.pfStructure,
        queryExt: {
          offerId: props.offerId,
          sceneId: props.sceneId
        },
        resultInfo: {
          index: props.index
        }
      })
    }

    return {
      ...toRefs(data),
      isType,
      getNewsType,
      goToContentDetail,
      goToNews
    }
  }
}
</script>
